const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgStar = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "28pt",
    height: "28pt",
    viewBox: "0 0 28 28",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 0.251,
    y1: 0.166,
    x2: 1,
    y2: 1.703,
    gradientTransform: "matrix(28,0,0,28,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(100%,100%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(78.431373%,78.431373%,78.431373%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 28 14 C 28 21.730469 21.730469 28 14 28 C 6.269531 28 0 21.730469 0 14 C 0 6.269531 6.269531 0 14 0 C 21.730469 0 28 6.269531 28 14 Z M 28 14 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(27.843137%,23.137255%,4.705882%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 43.997768 23 C 43.997768 34.596261 34.596261 43.997768 23 43.997768 C 11.403739 43.997768 2.002232 34.596261 2.002232 23 C 2.002232 11.403739 11.403739 2.002232 23 2.002232 C 34.596261 2.002232 43.997768 11.403739 43.997768 23 Z M 43.997768 23 ",
    transform: "matrix(0.608696,0,0,0.608696,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,75.686275%,2.745098%)",
      fillOpacity: 1,
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(27.843137%,23.137255%,4.705882%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 24.667969 19.922147 C 24.507533 19.421589 24.058315 19.068632 23.538504 19.02371 L 16.402344 18.369134 L 13.578683 11.759201 C 13.373326 11.277895 12.89202 10.963442 12.365792 10.963442 C 11.839565 10.963442 11.364676 11.277895 11.159319 11.759201 L 8.335658 18.369134 L 1.19308 19.017292 C 0.67327 19.068632 0.224051 19.421589 0.0636161 19.922147 C -0.0968192 20.422705 0.0507813 20.968185 0.448661 21.314725 L 5.852121 26.050775 L 4.254185 33.058587 C 4.138672 33.57198 4.337612 34.104625 4.761161 34.412661 C 5.191127 34.727114 5.755859 34.752783 6.211496 34.476835 L 12.365792 30.799658 L 18.520089 34.476835 C 18.975725 34.746366 19.546875 34.727114 19.970424 34.412661 C 20.393973 34.104625 20.59933 33.57198 20.4774 33.058587 L 18.885882 26.050775 L 24.289342 21.321143 C 24.680804 20.968185 24.834821 20.422705 24.667969 19.922147 Z M 24.667969 19.922147 ",
    transform: "matrix(0.608696,0,0,0.608696,6.695652,0.021913)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/star.89f33e8f52ba0bf85d0856f0bf2909f6.svg";